import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../setup/auth/authService';

const UserBox = () => {
  const { t } = useTranslation();
  const { user, signinRedirect, signoutRedirect } = useAuth();

  const preferredName = `${user?.profile?.given_name || ''} ${user?.profile?.family_name || ''}`.trim();
  const displayName = user?.profile?.name || preferredName || 'User';
  const avatarUrl = 'https://ui-avatars.com/api/?name=' + encodeURIComponent(displayName);
  
  return (
    <>
      <div className="gg-user-box ms-4">
      {(user && !user.expired) ? (
        <><img src={avatarUrl} alt="User avatar" className="gg-user-avatar" />
          <span className="gg-user-name">{displayName}</span>
          <button className="btn btn-outline-light btn-sm1 ms-3" onClick={signoutRedirect}>
            {t('Logout')}
          </button></>) 
        : (
  <button className="btn gg-btn-submit" onClick={signinRedirect}>{t('Login')}</button>
      )}
      </div>
    </>
  );
};

export default UserBox;